/* eslint-disable import/no-duplicates */

import enLocale from "date-fns/locale/en-US";
import jaLocale from "date-fns/locale/ja";
import zhLocale from "date-fns/locale/zh-TW";

import en from "./en";
import ja from "./ja";
import zh from "./zh";

export const dateFnsLocales: Record<string, any> = {
  en: enLocale,
  ja: jaLocale,
  zh: zhLocale,
};
export const messages: Record<string, any> = { en, ja, zh };
